module.exports = __webpack_public_path__ + "img/lct.9e9af62a.jpeg";